export const VARS = {
  price: {
    yearly: '$119',
    monthly: '$10',
  },
  cta: {
    message: 'Join Catch',
  },
};
